module.exports = "pegasus/assets/theme6/medium/3.jpg";